<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Stores
		//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);
	let settings = $settingsStore;
	let loading = false;
	let invertDirections =
		settings[`${get_gen_2_component_channel_structure(device)}`].invert_directions;

	const sendRequest = async (e: InputClickEvent) => {
		loading = true;
		invertDirections = e.target.checked;
		const params = {
			id: device.channel,
			config: { invert_directions: invertDirections },
		};

		const res: SettingRequest = await gen2Request(
			device,
			`${get_gen_2_component_from_category(device)}.SetConfig`,
			params,
		);

		if (res.isok) {
			settings[`${get_gen_2_component_channel_structure(device)}`].invert_directions =
				invertDirections;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('reverse_directions_scc_toast'),
			});
		} else {
			toast.open({ type: 'danger', title: $format('setting_err_toast') });
			invertDirections = !invertDirections;
		}
		loading = false;
	};
</script>

<Toggle
	disabled={loading}
	size="m"
	checked={invertDirections}
	on:click={sendRequest}
	id="toggle-olch34j"
>
	{$format('label_enable')}
</Toggle>
